import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1df3c246"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrapper"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "qr-scanner"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "line"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "angle"
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "txt"
}, " 将二维码/条码放入框内，即自动扫描 ")])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_qr_stream = _resolveComponent("qr-stream");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_qr_stream, {
    onDecode: $options.onDecode,
    onInit: $options.onInit,
    class: "mb"
  }, {
    default: _withCtx(() => [_hoisted_2]),
    _: 1
  }, 8, ["onDecode", "onInit"])]);
}